import React from 'react';
import { Settings, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SettingsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-12 animate-fade-in">
      {/* Header */}
      <div className="relative p-10 text-center space-y-6 bg-gradient-to-br from-gray-600 via-gray-700 to-gray-800 text-white shadow-xl rounded-2xl border border-gray-500/20">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-600/90 to-gray-800/90 rounded-2xl"></div>
        <div className="relative z-10">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
              <Settings className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t('nav.settings')}
          </h1>
          <p className="text-lg text-gray-100 max-w-3xl mx-auto leading-relaxed">
            Configuración del sistema • Próximamente disponible
          </p>
        </div>
      </div>

      {/* Coming Soon Message */}
      <div className="text-center py-16">
        <Settings className="w-20 h-20 text-neutral-400 mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-neutral-100 mb-4">Módulo en Desarrollo</h2>
        <p className="text-neutral-300 mb-8">Esta funcionalidad estará disponible próximamente</p>
        <a
          href="/dashboard"
          className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-300"
        >
          <ArrowRight className="w-4 h-4 mr-2" />
          Volver al Dashboard
        </a>
      </div>
    </div>
  );
};

export default SettingsPage;